import axios from "axios";
import { IP } from "utils/Host";
import { getMaxID } from "actions/getMaxID";
import { today_teraz } from "actions/today_teraz";
import DecodeToken from "pages/Login/DecodeToken";

export const addRealizajcaProcesu = async (
  setShow,
  wykonanie,
  value,
  wykonania,
  setWykonania,
  realizacje,
  setRealizacje,
  grupyWykonanAll,
  setGrupWykonanAll,
  grup,
  setIsLoading,socket,procesory,isBrak
) => {
  setIsLoading(true);


  try {
    let proces_nazwa_id = procesory?.find(x=>x.id == wykonanie.procesor_id).grupa

    const res = await axios.post(
      IP + "dodaj_realizacje_procesu/" + sessionStorage.getItem("token"),
      {
        ...wykonanie,
        zrealizowano: value,
        proces_nazwa_id: proces_nazwa_id,
        brak:isBrak
      }
    );

    const { status, insertId, status_wykonania, do_wykonania,status_grupy, zgloszonaNadwyzka,
            brakujace,
            zrealizowano,resRealizacje } = res.data;


            console.log("Zrealizowano: " + zrealizowano)
            console.log("brakujace: " + brakujace)
            console.log("zgloszonaNadwyzka: " + zgloszonaNadwyzka)

    if (status === "OK") {
      // const new_realizacje = realizacje.slice();
      // new_realizacje.push({
      //   ...wykonanie,
      //   id: getMaxID(realizacje),
      //   zrealizowano: value,
      //   dodal_id: DecodeToken(sessionStorage.getItem("token")).id,

      //   global_id: insertId,
      //   utworzono: today_teraz(),
      //   wykonanie_global_id: wykonanie.global_id,
      //   typ: isBrak? 2:1
      // });
      // setRealizacje(new_realizacje);
      setRealizacje(resRealizacje);

      

      setWykonania(
        wykonania.map((t) => {
          // Użyj unikalnego ID, tak jak w oryginale
          if (t.global_id === wykonanie.global_id) {
            return {
              ...t,
              status: status_wykonania,
              do_wykonania: do_wykonania,
            };
          }
          return t;
        })
      );


      setGrupWykonanAll(
        grupyWykonanAll.map((t) => {
          // Użyj unikalnego ID, tak jak w oryginale
          if (t.global_id === grup.global_id) {
            return {
              ...t,
              status: status_grupy,
            
            };
          }
          return t;
        })
      );



// socket.emit("realizacja")

    } else {
      alert(status.sqlMessage);
    }
    
    // setShow(false); // Opcjonalnie, jeśli chcesz ukryć modal po operacji
  } catch (error) {
    console.error("Wystąpił błąd:", error);
    alert("Wystąpił błąd podczas dodawania realizacji procesu.");
  }finally {
        
        setIsLoading(false);
      }
};